var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66797 16.6665H18.3346V18.3332H1.66797V16.6665ZM3.33464 9.99984H5.0013V15.8332H3.33464V9.99984ZM7.5013 9.99984H9.16797V15.8332H7.5013V9.99984ZM10.8346 9.99984H12.5013V15.8332H10.8346V9.99984ZM15.0013 9.99984H16.668V15.8332H15.0013V9.99984ZM1.66797 5.83317L10.0013 1.6665L18.3346 5.83317V9.1665H1.66797V5.83317ZM3.33464 6.86323V7.49984H16.668V6.86323L10.0013 3.5299L3.33464 6.86323ZM10.0013 6.6665C9.54105 6.6665 9.16797 6.2934 9.16797 5.83317C9.16797 5.37294 9.54105 4.99984 10.0013 4.99984C10.4616 4.99984 10.8346 5.37294 10.8346 5.83317C10.8346 6.2934 10.4616 6.6665 10.0013 6.6665Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankLine);
export default __webpack_public_path__ + "static/media/bank-line.373b08cfec5ee2252227f63b439d4510.svg";
export { ForwardRef as ReactComponent };